import iosSwitch from '/assets/images/iosswitch.jpg'

export default ({show}) => {
  return show ? (
    <>
      <div className="inset">
        <div className="setting flex w-full flex-row justify-between">
          <div>Automatic Update</div>
          <div><img src={iosSwitch} /></div>
        </div>

        <hr />
        
        <div className="setting flex w-full flex-row justify-between">
          <div>Allow Notifications</div>
          <div><img src={iosSwitch} /></div>
        </div>

        <div className="setting flex w-full flex-row justify-between">
          <div>Suggest on Lock Screen</div>
          <div><img src={iosSwitch} /></div>
        </div>
      </div>

      <div className="inset">
        <span className="remove">Remove Pass</span>
      </div>
    </>
  ) : ''
}